"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Building2, TrendingUp, FolderOpen, Search, MapPin, ChartLine } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  name: "Property Sourcing",
  description: "Find verified properties across Lagos, Abuja, and Port Harcourt with our expert market intelligence.",
  icon: Building2
}, {
  id: 2,
  name: "Investment Analysis",
  description: "Data-driven insights to help you make informed real estate investment decisions.",
  icon: TrendingUp
}, {
  id: 3,
  name: "Portfolio Management",
  description: "Strategic management of your real estate assets for maximum returns.",
  icon: FolderOpen
}, {
  id: 4,
  name: "SEO Audits",
  description: "Comprehensive website audits to uncover optimization opportunities and boost visibility.",
  icon: Search
}, {
  id: 5,
  name: "Google Business Profile Optimization",
  description: "Maximize your local presence and attract qualified leads through optimized profiles.",
  icon: MapPin
}, {
  id: 6,
  name: "Website SEO Score Checker",
  description: "Interactive tool to assess your website's performance and receive actionable recommendations.",
  icon: ChartLine
}];
export default function OurServicesSnapshot() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section ref={ref} className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold text-foreground md:text-4xl">
            Our Services Snapshot
          </h2>
          <p className="mx-auto max-w-2xl text-base text-muted-foreground md:text-lg">
            Explore our comprehensive suite of real estate and digital marketing services designed to give you an unfair advantage.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Link key={service.id} to="/ServicesPage" data-index={i} className="block transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <Card className={`h-full shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`} style={{
              animationDelay: isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <CardHeader className="pb-4">
                    <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110">
                      <Icon className="h-6 w-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {service.name}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}